import { render, staticRenderFns } from "./StdizerView.vue?vue&type=template&id=caf08194&scoped=true"
import script from "./StdizerView.vue?vue&type=script&setup=true&lang=js"
export * from "./StdizerView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./StdizerView.vue?vue&type=style&index=0&id=caf08194&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf08194",
  null
  
)

export default component.exports